"use strict";

import { AppDispatcher } from 'Dispatcher';
import { FormEditTableConstants } from "Constants/Forms/FormEditTableConstants";
export function formEditTableFormShowTable(show, formUUID) {
  AppDispatcher.dispatch({
    actionType: FormEditTableConstants.FORM_EDIT_TABLE_FORM_SHOW_TABLE,
    show: show,
    formUUID: formUUID
  });
}
export function loadTableContextMenuData(dataContextMenu, formUUID) {
  AppDispatcher.dispatch({
    actionType: FormEditTableConstants.LOAD_TABLE_CONTEXT_MENU_DATA,
    dataContextMenu: dataContextMenu,
    formUUID: formUUID
  });
}